import { SYSTEM_USER } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import type { WebItemLocationQueryType } from '@confluence/web-item-location/entry-points/WebItemLocationQuery.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadProfileMenu = (): Promise<void | {
	data: WebItemLocationQueryType | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return preloadWebItemLocation({ location: SYSTEM_USER });
};
